/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import {css, CSSResultOrNative, html, LitElement} from 'lit';
import {property} from 'lit/decorators.js';
import {
  internals,
  mixinElementInternals,
} from '../../../behaviors/element-internals.js';

import listStyles from './list.css' with {type: 'css'}; // github-only
// import {styles as listStyles} from './list.cssresult.js'; // google3-only

import {list} from './list.js';

// Separate variable needed for closure.
const baseClass = mixinElementInternals(LitElement);

/**
 * A Material Design list component.
 *
 * @slot - Used to display list items.
 * @csspart list - The list's root element.
 * @cssprop --container-shape
 * @cssprop --gap
 */
export class ListElement extends baseClass {
  static override styles: CSSResultOrNative[] = [
    listStyles,
    css`
      :host {
        display: flex;
      }
      .list {
        flex: 1;
      }
    `,
  ];

  constructor() {
    super();
    this[internals].role = 'list';
  }

  /**
   * Whether to render the list with segmented items.
   */
  @property({type: Boolean}) segmented = false;

  protected override render() {
    return html`<div part="list" class="${list(this)}">
      <slot></slot>
    </div>`;
  }
}
